/* MkaeSense 3D city globe v4: lit ocean, land, borders, one dot per city, focus city, smart labels, and zoom (pinch, wheel, double-tap, buttons). Helpers load from mk-g3lib.js. */
(function () {
var me = (document.currentScript && document.currentScript.src) || (document.querySelector('script[src*="mk-globe3d.js"]') || {}).src || '', libP = null, G = null;
function lib() {
if (!libP) libP = window.MKG3 ? Promise.resolve() : new Promise(function (ok, no) { var s = document.createElement('script'); s.src = me.split('?')[0].replace(/mk-globe3d\.js$/, 'mk-g3lib.js'); s.onload = ok; s.onerror = no; document.head.appendChild(s); });
return libP.then(function () { G = window.MKG3; });
}
window.mkG3data = function (u) { return lib().then(function () { return G.getData(u); }); };
function Globe(el) {
G.css();
var self = this, focus = el.dataset.focus || '', metric = +(el.dataset.metric || 0), reduce = G.reduce, v3 = G.v3, ease = G.ease;
var W = el.clientWidth, H = el.clientHeight || W;
el.setAttribute('aria-label', '3D globe of US and Canadian cities. Each dot is a city, coloured from blue (less reported crime per person) to red (more). Use the zoom buttons, pinch or double-tap to zoom in.');
var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1)); renderer.setSize(W, H);
el.appendChild(renderer.domElement);
var scene = new THREE.Scene(), cam = new THREE.PerspectiveCamera(30, W / H, 0.1, 50);
var dist = +(el.dataset.dist || (focus ? 1.95 : 3.75)), zs = focus ? 0.5 : 1; cam.position.set(0, 0, dist);
var D0 = dist, Dmin = Math.max(1.18, 1 + (D0 - 1) * 0.06), zD = D0, zT = D0, landMat = null, nLab = 0, lab0 = 0;
var world = new THREE.Group(); scene.add(world);
var sphere = G.ocean(); world.add(sphere); scene.add(G.glow());
var beacons, rows, cur = [], tgt = [], growT = 0, focusRow = null, ring, label, focusDisc, labs = [];
var ray = new THREE.Raycaster(), mouse = new THREE.Vector2(), hover = -1;
function addLab(r) { var d = document.createElement('div'); d.className = 'g3-lab'; d.textContent = r[1]; d.style.opacity = 0; el.appendChild(d); labs.push({ r: r, el: d }); }
self.ready = Promise.all([G.boot(), G.getData(el.dataset.src)]).then(function (res) {
var geo = res[0], rs = res[1], pos = new Float32Array(geo.dots.length / 2 * 3);
for (var i = 0; i < geo.dots.length; i += 2) { var p = v3(geo.dots[i], geo.dots[i + 1], 1.0); pos.set([p.x, p.y, p.z], i / 2 * 3); }
var dg = new THREE.BufferGeometry(); dg.setAttribute('position', new THREE.BufferAttribute(pos, 3));
landMat = new THREE.PointsMaterial({ color: 0x7f9cc8, size: 0.0115 * zs, sizeAttenuation: true, transparent: true, opacity: 0.95, depthWrite: false });
world.add(new THREE.Points(dg, landMat));
world.add(G.lines(geo.coast, 1.0015, 0x9cc0ff, 0.75));
world.add(G.lines(geo.borders, 1.0015, 0x7e9ccc, 0.5));
G.getStates().then(function (s) { if (s.length) { world.add(G.lines(s, 1.0012, 0x6c88b8, 0.42)); kick(); } });
build(rs);
});
function build(rs) {
rows = rs;
var n = rows.length, bp = new Float32Array(n * 3);
rows.forEach(function (r, i) { cur[i] = 0; if (r[0] === focus) focusRow = r; var p = v3(r[4], r[5], 1.004); bp.set([p.x, p.y, p.z], i * 3); });
var bg = new THREE.BufferGeometry(); bg.setAttribute('position', new THREE.BufferAttribute(bp, 3));
bg.setAttribute('color', new THREE.BufferAttribute(new Float32Array(n * 3), 3)); bg.setAttribute('s', new THREE.BufferAttribute(new Float32Array(n), 1));
beacons = new THREE.Points(bg, G.beaconMat());
sizeK(); world.add(beacons);
if (focusRow) {
var fp = v3(focusRow[4], focusRow[5], 1.006), out = fp.clone().multiplyScalar(2);
var mk = new THREE.Group(); mk.position.copy(fp); mk.lookAt(out); world.add(mk);
mk.add(new THREE.Mesh(new THREE.CircleGeometry(0.019 * zs, 40), new THREE.MeshBasicMaterial({ color: 0xffffff, depthWrite: false, transparent: true })));
focusDisc = new THREE.Mesh(new THREE.CircleGeometry(0.014 * zs, 40), new THREE.MeshBasicMaterial({ color: 0xffffff, depthWrite: false, transparent: true })); focusDisc.position.z = 0.0005; mk.add(focusDisc);
ring = new THREE.Mesh(new THREE.RingGeometry(0.024 * zs, 0.028 * zs, 48), new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.9, side: THREE.DoubleSide, depthWrite: false })); mk.add(ring);
label = document.createElement('div'); label.className = 'g3-label'; label.textContent = focusRow[1]; el.appendChild(label);
var f = v3(focusRow[4], focusRow[5], 1);
rows.filter(function (r) { return r !== focusRow && v3(r[4], r[5], 1).dot(f) > Math.cos(14 * Math.PI / 180); })
.sort(function (a, b) { return b[6] - a[6]; }).slice(0, 40).forEach(addLab);
lab0 = 8; aim(focusRow[4], focusRow[5]);
} else {
rows.slice().sort(function (a, b) { return b[6] - a[6]; }).slice(0, 220).forEach(addLab);
lab0 = 28; aim(+(el.dataset.lat || 46), +(el.dataset.lon || -96));
}
setMetric(metric, true); updZ();
el.classList.add('is-ready'); growT = reduce ? 1 : 0; t0 = performance.now(); kick();
}
function zf() { return (zD - 1) / (D0 - 1); }
function sizeK() {
var z = zf();
if (beacons) beacons.material.uniforms.k.value = H * renderer.getPixelRatio() / (2 * Math.tan(cam.fov * Math.PI / 360)) * Math.pow(z, 0.72);
if (landMat) landMat.size = 0.0115 * zs * Math.pow(z, 0.55);
ray.params.Points.threshold = 0.012 * zs * Math.pow(z, 0.72);
}
function size(r) { return r === focusRow ? 0 : (focus ? 0.0062 : 0.0125) * (r.p[metric] == null ? 0.8 : 1); }
function setMetric(m, first) {
metric = m; if (!rows) return;
var bc = beacons.geometry.attributes.color;
rows.forEach(function (r, i) {
tgt[i] = size(r); var c = r.p[m] == null ? [0.45, 0.5, 0.58] : G.ramp(r.p[m]); bc.setXYZ(i, c[0], c[1], c[2]);
});
if (focusDisc) { var fc = focusRow.p[m] == null ? [0.6, 0.64, 0.7] : G.ramp(focusRow.p[m]); focusDisc.material.color.setRGB(fc[0], fc[1], fc[2]); }
bc.needsUpdate = true; if (!first) { from = cur.slice(); mt0 = performance.now(); } kick();
}
self.setMetric = setMetric;
var from = null, mt0 = 0, t0 = 0, rot = { x: 0, y: 0 }, aimR = { x: 0, y: 0 }, vel = { x: 0, y: 0 }, drag = false, idle = 0, home = [0, 0];
function aim(lat, lon) {
home = [lat, lon];
aimR.y = -lon * Math.PI / 180; aimR.x = Math.max(-1.1, Math.min(1.1, lat * Math.PI / 180 * (focus ? 1 : 0.85)));
if (reduce) { rot.x = aimR.x; rot.y = aimR.y; } else { rot.y = aimR.y + 1.2; rot.x = aimR.x * 0.4; }
}
function turn(lat, lon, k) {
var ty = -lon * Math.PI / 180; ty += 2 * Math.PI * Math.round((rot.y - ty) / (2 * Math.PI));
aimR.y = ty; aimR.x = Math.max(-1.2, Math.min(1.2, lat * Math.PI / 180 * k)); vel.x = vel.y = 0; idle = -600; kick();
}
self.aim = function (lat, lon) { turn(lat, lon, 0.85); };
function zoomTo(z, lat, lon) { zT = Math.max(Dmin, Math.min(D0, z)); if (lat != null) turn(lat, lon, 1); idle = 0; kick(); }
function zoomBy(k, lat, lon) { zoomTo(1 + (zT - 1) * k, lat, lon); }
function fit() { zoomTo(D0); turn(home[0], home[1], focus ? 1 : 0.85); }
self.zoomBy = zoomBy; self.fit = fit;
var ui = G.zoomUI(el, function (z) { if (z === 'in') zoomBy(0.45); else if (z === 'out') zoomBy(2.2); else fit(); }), lastZ = '';
function updZ() {
var m = (D0 - 1) / (zD - 1), s = m.toFixed(1) + (zT >= D0 - 0.004) + (zT <= Dmin + 0.004);
if (s !== lastZ) { lastZ = s; ui.set(m, zT >= D0 - 0.004, zT <= Dmin + 0.004); }
var zl = Math.max(0, Math.min(1, Math.log(m) / Math.log((D0 - 1) / (Dmin - 1))));
nLab = Math.round(lab0 + zl * (labs.length - lab0));
cv.style.touchAction = zT < D0 - 0.01 ? 'none' : '';
}
function place() { var a = beacons.geometry.attributes.s; for (var i = 0; i < rows.length; i++) a.setX(i, cur[i]); a.needsUpdate = true; }
var running = false, visible = true, dirty = true;
function kick() { if (!running && visible) { running = true; requestAnimationFrame(frame); } }
function frame(now) {
running = false; if (!rows) return;
var busy = false;
if (growT < 1) { growT = Math.min(1, (now - t0) / 1600); busy = true; }
var g = ease(growT);
if (from || busy || dirty) {
for (var i = 0; i < rows.length; i++) {
if (from) { var k = ease(Math.min(1, (now - mt0) / 650)); cur[i] = from[i] + (tgt[i] - from[i]) * k; if (k >= 1 && i === rows.length - 1) from = null; else busy = true; }
else cur[i] = tgt[i] * g;
}
place(); dirty = busy;
}
if (Math.abs(zT - zD) > 0.0003) { zD += (zT - zD) * (pinch ? 0.45 : 0.14); if (Math.abs(zT - zD) <= 0.0003) zD = zT; cam.position.z = zD; sizeK(); updZ(); busy = true; }
if (!drag && !pinch) {
rot.y += (aimR.y - rot.y) * 0.06 + vel.y; rot.x += (aimR.x - rot.x) * 0.06 + vel.x;
vel.x *= 0.92; vel.y *= 0.92; aimR.y += vel.y; aimR.x = Math.max(-1.2, Math.min(1.2, aimR.x + vel.x));
if (Math.abs(vel.y) + Math.abs(vel.x) > 0.0002 || Math.abs(aimR.y - rot.y) > 0.0005 || Math.abs(aimR.x - rot.x) > 0.0005) busy = true;
if (!reduce && !focus && zT >= D0 - 0.01 && ++idle > 300) { aimR.y -= 0.0007; busy = true; }
} else busy = true;
world.rotation.set(rot.x, rot.y, 0);
if (ring) { var ph = (now / 1600) % 1, s = 1 + 1.1 * ph; ring.scale.set(s, s, 1); ring.material.opacity = 0.9 * (1 - ph); if (!reduce) busy = true; }
tagLabels();
renderer.render(scene, cam);
if (busy) kick();
}
function proj(lat, lon, r) { var p = v3(lat, lon, r); p.applyMatrix4(world.matrixWorld); var front = p.clone().normalize().dot(cam.position.clone().normalize()); p.project(cam); return { x: (p.x + 1) / 2 * W, y: (1 - p.y) / 2 * H, f: front }; }
function tagLabels() {
world.updateMatrixWorld(); var boxes = [], fmin = zD < 1.6 ? 0.9 : 0.35;
if (label) {
var q = proj(focusRow[4], focusRow[5], 1.006); label.style.transform = 'translate(' + q.x + 'px,' + q.y + 'px)'; label.style.opacity = q.f > 0.2 ? 1 : 0;
var lw = label.offsetWidth || 90; boxes.push([q.x - lw / 2 - 6, q.y - 58, q.x + lw / 2 + 6, q.y + 14]);
}
labs.forEach(function (l, i) {
if (i >= nLab) { if (l.on !== 0) { l.el.style.opacity = 0; l.on = 0; } return; }
var q = proj(l.r[4], l.r[5], 1.004), w = l.w || (l.w = l.el.offsetWidth || 60);
var bx = [q.x - 6, q.y - 9, q.x + w + 4, q.y + 9], ok = q.f > fmin && q.x > 4 && q.x + w < W - 4 && q.y > 10 && q.y < H - 10;
if (ok) for (var j = 0; j < boxes.length; j++) { var o = boxes[j]; if (bx[0] < o[2] && bx[2] > o[0] && bx[1] < o[3] && bx[3] > o[1]) { ok = false; break; } }
if (ok) boxes.push(bx);
l.el.style.transform = 'translate(' + q.x + 'px,' + q.y + 'px)'; if (l.on !== +ok) { l.el.style.opacity = ok ? 1 : 0; l.on = +ok; }
});
}
var cv = renderer.domElement, lx, ly, moved = 0, pts = {}, pinch = null, engaged = false, lastTap = 0, tapX = 0, tapY = 0, tip = document.createElement('div'); tip.className = 'g3-tip'; tip.hidden = true; el.appendChild(tip);
function setMouse(e) { var b = cv.getBoundingClientRect(); mouse.set((e.clientX - b.left) / b.width * 2 - 1, -(e.clientY - b.top) / b.height * 2 + 1); ray.setFromCamera(mouse, cam); return b; }
function hitDot(e) { if (!beacons) return -1; setMouse(e); var t = ray.params.Points.threshold; if (e.pointerType === 'touch') ray.params.Points.threshold = t * 2.5; var h = ray.intersectObject(beacons)[0]; ray.params.Points.threshold = t; return h ? h.index : -1; }
function hitGlobe(e) { setMouse(e); var h = ray.intersectObject(sphere)[0]; if (!h) return null; var p = world.worldToLocal(h.point.clone()).normalize(); return [Math.asin(p.y) * 180 / Math.PI, Math.atan2(p.x, p.z) * 180 / Math.PI]; }
function two() { var ids = Object.keys(pts); return ids.length >= 2 ? [pts[ids[0]], pts[ids[1]]] : null; }
cv.addEventListener('pointerdown', function (e) {
pts[e.pointerId] = { x: e.clientX, y: e.clientY }; engaged = true; idle = 0;
try { cv.setPointerCapture(e.pointerId); } catch (x) {}
var t = two();
if (t) { pinch = { d: Math.hypot(t[0].x - t[1].x, t[0].y - t[1].y) || 1, z: zT, mx: (t[0].x + t[1].x) / 2, my: (t[0].y + t[1].y) / 2 }; drag = false; moved = 99; tip.hidden = true; }
else { drag = true; moved = 0; lx = e.clientX; ly = e.clientY; }
kick();
});
cv.addEventListener('pointermove', function (e) {
if (pts[e.pointerId]) pts[e.pointerId] = { x: e.clientX, y: e.clientY };
var sp = 0.005 * zs * Math.max(zf(), 0.05);
if (pinch) {
var t = two(); if (!t) return;
var d = Math.hypot(t[0].x - t[1].x, t[0].y - t[1].y) || 1, mx = (t[0].x + t[1].x) / 2, my = (t[0].y + t[1].y) / 2;
zT = Math.max(Dmin, Math.min(D0, 1 + (pinch.z - 1) * pinch.d / d));
rot.y += (mx - pinch.mx) * sp; rot.x = Math.max(-1.2, Math.min(1.2, rot.x + (my - pinch.my) * sp)); aimR.y = rot.y; aimR.x = rot.x;
pinch.mx = mx; pinch.my = my; kick(); return;
}
if (drag) {
var dx = e.clientX - lx, dy = e.clientY - ly; lx = e.clientX; ly = e.clientY; moved += Math.abs(dx) + Math.abs(dy);
rot.y += dx * sp; rot.x = Math.max(-1.2, Math.min(1.2, rot.x + dy * sp)); aimR.y = rot.y; aimR.x = rot.x; vel.y = dx * sp * 0.16; vel.x = dy * sp * 0.16; tip.hidden = true; return;
}
if (e.pointerType !== 'mouse' || !beacons) return;
hover = hitDot(e);
if (hover >= 0) {
var r = rows[hover], lab = ['Break-ins', 'Car thefts', 'Thefts', 'Violent crimes'][metric], b = cv.getBoundingClientRect();
tip.innerHTML = '<b></b><span></span>'; tip.firstChild.textContent = r[1] + ', ' + r[2];
tip.lastChild.textContent = r[7 + metric] == null ? lab + ': not reported' : lab + ': ' + (r[7 + metric]).toFixed(1) + ' per 1,000 residents';
tip.style.transform = 'translate(' + (e.clientX - b.left) + 'px,' + (e.clientY - b.top) + 'px)'; tip.hidden = false; cv.style.cursor = 'pointer';
} else { tip.hidden = true; cv.style.cursor = ''; }
});
function up(e) {
delete pts[e.pointerId];
if (pinch) { if (!two()) pinch = null; drag = false; idle = 0; kick(); return; }
var click = drag && moved < 6; drag = false; idle = 0; kick();
if (!click) return;
var hit = hitDot(e);
if (hit >= 0 && rows[hit][0] !== focus) { location.href = '/pages/city/' + rows[hit][0]; return; }
var now = performance.now();
if (now - lastTap < 340 && Math.abs(e.clientX - tapX) + Math.abs(e.clientY - tapY) < 40) { lastTap = 0; var ll = hitGlobe(e); if (ll) zoomBy(0.4, ll[0], ll[1]); }
else { lastTap = now; tapX = e.clientX; tapY = e.clientY; }
}
cv.addEventListener('pointerup', up);
cv.addEventListener('pointercancel', function (e) { delete pts[e.pointerId]; pinch = null; drag = false; kick(); });
cv.addEventListener('pointerleave', function () { tip.hidden = true; engaged = false; });
cv.addEventListener('wheel', function (e) {
if (!(e.ctrlKey || engaged || zT < D0 - 0.01)) return;
e.preventDefault();
zoomTo(1 + (zT - 1) * Math.exp(e.deltaY * (e.ctrlKey ? 0.012 : 0.0016) * (e.deltaMode === 1 ? 16 : 1)));
}, { passive: false });
cv.addEventListener('dblclick', function (e) { e.preventDefault(); });
if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) kick(); }).observe(el);
if (window.ResizeObserver) new ResizeObserver(function () {
var w = el.clientWidth, h = el.clientHeight || w; if (!w || (w === W && h === H)) return;
W = w; H = h; renderer.setSize(W, H); cam.aspect = W / H; cam.updateProjectionMatrix(); sizeK(); kick();
}).observe(el);
}
function start() {
var els = document.querySelectorAll('[data-g3]'); if (!els.length) return;
lib().then(function () {
if (!G.supported()) { els.forEach(function (e) { e.classList.add('is-failed'); }); return; }
var go = function (el) {
G.boot().then(function () { var g = new Globe(el); el.__g3 = g; document.dispatchEvent(new CustomEvent('g3:ready', { detail: { el: el, globe: g } })); })
.catch(function () { el.classList.add('is-failed'); });
};
var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); go(e.target); } }); }, { rootMargin: '300px' });
els.forEach(function (e) { io.observe(e); });
}).catch(function () { els.forEach(function (e) { e.classList.add('is-failed'); }); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();